export default __webpack_public_path__ + "static/media/fakurian-design.9d83ef53.png";